import { render, staticRenderFns } from "./FetchData.vue?vue&type=template&id=e58ee09a&"
import script from "./FetchData.vue?vue&type=script&lang=js&"
export * from "./FetchData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports